import axiosInstance, { axiosInstanceZIP, axiosInstanceImage } from "@helper/interceptor";
import { store } from "../../../redux/store";

export const getAllProjects = async () => {
  let response = await axiosInstance.get("projects-general/");
  return response.data;
};

export const getProject = async (pid) => {
  // Safety check: never call API for pseudo-projects
  if (pid === "without-project" || !pid) {
    throw new Error("Cannot fetch pseudo-project from API");
  }
  let response = await axiosInstance.get(`projects/${pid}/`);
  if (response.status === 200) return response.data;
};

export const getPublicProject = async (pid) => {
  let response = await axiosInstance.get(`public/projects/${pid}/`);
  if (response.status === 200) return response.data;
};

export const createProject = async (formData) => {
  let response = await axiosInstance.post("projects/", formData);
  return response.data;
};

export const updateProject = async (form) => {
  let data = form.formData;
  let response = await axiosInstance.patch(`projects/${form.id}/`, data);
  return response.data;
};

export const deleteProject = async (id) => {
  let response = await axiosInstance.delete(`projects/${id}/`);
  return response.data;
};

export const downloadProject = async ({ project, includeMeanValues, startDate, endDate }) => {
  const today = new Date().toISOString().slice(0, 10);
  const thirtyDaysAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

  const params = new URLSearchParams({
    project: String(project.id),
    include_mean_values: String(!!includeMeanValues),
    start_date: startDate || thirtyDaysAgo,
    end_date: endDate || today,
  });

  const response = await axiosInstanceZIP.get(`download/?${params}`, {
    responseType: "blob",
  });

  const blob = new Blob([response.data], { type: "application/zip" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `${project.name}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();

  window.URL.revokeObjectURL(url);
};

export const createProjectDownloadJob = async ({
  project,
  includeMeanValues,
  startDate,
  endDate,
}) => {
  const today = new Date().toISOString().slice(0, 10);
  const thirtyDaysAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

  const payload = {
    project: String(project.id),
    include_mean_values: String(!!includeMeanValues),
    start_date: startDate || thirtyDaysAgo,
    end_date: endDate || today,
  };

  const response = await axiosInstance.post("download/jobs/", payload);
  return response.data;
};

export const getProjectDownloadJob = async (jobId) => {
  const response = await axiosInstance.get(`download/jobs/${jobId}/`);
  return response.data;
};

export const downloadProjectJobFile = async ({ jobId, projectName }) => {
  const response = await axiosInstanceZIP.get(`download/jobs/${jobId}/file/`, {
    responseType: "blob",
  });

  const blob = new Blob([response.data], { type: "application/zip" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `${projectName || "project_export"}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();

  window.URL.revokeObjectURL(url);
};

export const onRequest = (config) => {
  const states = store.getState();

  const accessToken = states.auth.authToken;
  config.headers = {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
    Authorization: "JWT " + accessToken,
  };
  return config;
};

export const addProjectImage = async ({ form, pId }) => {
  // Use dedicated image instance for file uploads
  let response = await axiosInstanceImage.post(`projects/${pId}/upload-image`, form);
  return response.data;
};

export const addProjectMaterials = async ({ form, pId }) => {
  let response = await axiosInstanceImage.post(`projects/${pId}/upload-materials`, form);
  return response.data;
};

export const removeProjectTree = async ({ data }) => {
  let response = await axiosInstance.patch(`trees/${data.tree_id}/remove-from-area`);
  return response.data;
};
